import { Directive, TemplateRef } from '@angular/core';

/**
 * Structural Directive to get a reference to the template/DOM.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[carouselItem]',
  standalone: false,
})
export class CarouselItemDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
